import {
	Id,
	LaravelResponse,
	ModelUsageResource,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { OrganizerSaveRequest } from "../../../../shared/types/organizer";
import { OrganizerIndexResource, OrganizerUpdateResource } from "../types";

const baseKey = ["organizers"];
const showUsageKey = (organizerId: Id) => [...organizerService.showKey(organizerId), "usage"];

export const organizerService = {
	...withIndexEndpoint<OrganizerIndexResource>(baseKey),
	...withShowEndpoint<OrganizerUpdateResource>(baseKey),
	...withStoreEndpoint<OrganizerSaveRequest>(baseKey),
	...withUpdateEndpoint<OrganizerSaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
	showUsageKey,
	showUsage: (organizerId: Id) => axios.get<LaravelResponse<ModelUsageResource[]>>(keyToUrl(showUsageKey(organizerId))),
};
